module.exports = __webpack_public_path__ + "static/media/too_much_debt.26890085.mp3";